import { Instance, types } from 'mobx-state-tree';

const Errors = types.model({
  fetchingAccountsPayableLink: types.optional(types.boolean, false),
});

export interface ErrorsStore extends Instance<typeof Errors> {}
export default Errors;
